import React, { useState } from 'react'
import { CButton } from 'app/components/Common/'
import { useTranslation } from 'react-i18next'
import { COLORS } from 'app/constants/STYLES'
import { apiError, checkEmail } from 'utils/ExpensiveFunction'

import ErrorHandling from './ErrorHandling'
import { InputSection } from '../AuthContainers'
import { BtnContainer } from '../styles'
import API from 'utils/api'
import { message } from 'antd'
import { useToken } from '../../../hooks'

const EMAIL = 'email'
const PHONE = 'phone'
const LoginForm = ({ setLoginSuccess }) => {
	const { t } = useTranslation()
	const { mutate } = useToken()
	const [tab, setTab] = useState(EMAIL)
	const [error, setError] = useState<string>('')
	const [success, setSuccess] = useState<string>('')

	const [email, setEmail] = useState('')
	const [mobile, setMobile] = useState<any>({
		country_code: '',
		iso_code: '',
		phone: '',
	})
	const [password, setPassword] = useState('')

	const handleSubmit = async () => {
		try {
			const res = await API.send('POST', '/auth/adsignin', null, {
				type: tab,
				email: email,
				iso_code: tab === PHONE ? mobile?.iso_code : '',
				country_code: tab === PHONE ? mobile?.country_code : '',
				phone: tab === PHONE ? mobile?.phone : '',
				password: password,
				referral_code: '',
			})

			if (res.result.success) {
				message.success(t('loginSuccessMessage'))
				if (res?.result?.token) {
					mutate(res?.result?.token)
				} else {
					setLoginSuccess(res?.result?.verifyid)
				}
			} else {
				const errorResult = apiError(t, res.result.msgcode)
				message.error(t(errorResult) + '')
				setError(t(errorResult))
			}
		} catch (e) {
			console.log(e, 'ERROR LOGIN')
		}
	}

	return (
		<>
			{error?.length > 3 ? (
				<ErrorHandling success={success} error={error} />
			) : null}
			{/* input section */}
			<InputSection
				type={tab}
				id={tab === EMAIL ? email : mobile}
				setId={tab === EMAIL ? setEmail : setMobile}
				password={password}
				setPassword={setPassword}
				onKeyWown={e => {
					handleSubmit()
				}}
			/>

			<BtnContainer>
				<CButton
					title={t('login')}
					onClick={event => {
						event.preventDefault()
						handleSubmit()
					}}
					style={{
						fontSize: 16,
						fontWeight: 600,
						paddingBlock: 14,
						width: '100%',
						color: COLORS.white,
						letterSpacing: '0.5px',
						textTransform: 'uppercase',
					}}
				/>
			</BtnContainer>
		</>
	)
}

export default React.memo(LoginForm)
